export const extractPxFromString = (size: string): number => {
  if (!size) return 0;
  if (!isNaN(Number(size))) {
    return Number(size);
  } else if (size.includes('px')) {
    return Number(size.slice(0, -2));
  }
  return 0;
};
